// extracted by mini-css-extract-plugin
export default {"menuWrapper":"index_menuWrapper__aQ4aA","menuLeft":"index_menuLeft__M9ieC","menuMiddle":"index_menuMiddle__8EBeh","menuRight":"index_menuRight__sIJ5K"};